import { Component, OnInit } from '@angular/core';
import {SessionServiceService} from '../services/session-service.service';
import {Router} from '@angular/router';
import {IImageWrapper} from '../../models/image-wrapper';
import {FormControl, FormGroup, Validators} from '@angular/forms';
import {removeCurrentlySelectedImageFromImagesFromFile} from '../main/main.component';
import { LoggerService } from "../services/logger/logger.service";
import { UI_ACTION_CONSTANTS, REPLACEMENT_ACTION_CONSTANTS } from '../services/logger/constants';

@Component({
  selector: 'app-exclude-from-overall-license',
  templateUrl: './exclude-from-overall-license.component.html',
  styleUrls: ['./exclude-from-overall-license.component.scss']
})
export class ExcludeFromOverallLicenseComponent implements OnInit {

  public formGroup: FormGroup;

  constructor(
    public _session: SessionServiceService,
    private _logger: LoggerService,
    private _router: Router
  ) { }

  ngOnInit() {
    this.formGroup = new FormGroup({
      description: new FormControl(null),
      withoutMention: new FormControl(false)
    });
  }

  public goToMain(): void {
    this._router.navigate(['']);
  }

  public getToolbarTitle(): string {
    return this._session.getToolName() + ' ' + this._session.getCurrentToolVersion();
  }

  public getCurrentlySelectedImageFromFile(): IImageWrapper[] {
    return this._session.getCurrentlySelectedImageFromFile();
  }

  public excludeImage(): void {
    console.log('excluding it!');
    for(const img of this.getCurrentlySelectedImageFromFile()){
    this._session.getFileHandler().EnqueueExcludeFromLicense(img,this.formGroup.get('withoutMention').value,`"${this.formGroup.get('description').value?.toString()}"`)
    }
    removeCurrentlySelectedImageFromImagesFromFile(this._session);
    // If text should be included
    // if (!this.formGroup.get('withoutMention').value){
    //   this._session.excludeImageFromOverallLicense(this.formGroup.get('description').value.toString());
    // }

    // log image excluded ui action
    this._logger.log(UI_ACTION_CONSTANTS.IMAGE_REPLACED, {
      replacementAction: REPLACEMENT_ACTION_CONSTANTS.EXCLUDE_FROM_LICENSE,
      sourceImage: this.getCurrentlySelectedImageFromFile().map(img => img.source),
      excludeWithoutMention: this.formGroup.get('withoutMention').value,
      description: this.formGroup.get('description').value ? this.formGroup.get('description').value.toString() : "",
    });

    this.goToMain();
  }


  public getTextFieldLabel(): string {
    return this.formGroup.get('withoutMention').value ? ($localize `Disabled as without mention is selected`) : "";
  }

  public getButtonText(): string {
    return this.formGroup.get('withoutMention').value ? $localize `Exclude without mention` : $localize `Exclude`;
  }
}
